document.addEventListener("DOMContentLoaded", function () {
  const pagetop = document.getElementById("page-top");
  if (!pagetop) return;

  // 初期状態で非表示
  pagetop.style.display = "none";

  // スクロール監視
  window.addEventListener("scroll", function () {
    if (window.scrollY > 100) {
      pagetop.style.display = "block";
      pagetop.style.opacity = "1";
    } else {
      pagetop.style.display = "none";
    }
  });

  // クリックでトップへ
  pagetop.addEventListener("click", function (e) {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
});
